import http from '@/axios/http'

// 获取全部打印机驱动
export function queryPrinterList(data) {
  return http({
    url: '/api/printDrive/list',
    method: 'post',
    data
  })
}
// 删除
export function deletePrinter(data) {
  return http({
    url: '/api/printDrive/del',
    method: 'post',
    data
  })
}
// 添加
export function addPrinter(data) {
  return http({
    url: '/api/printDrive/add',
    method: 'post',
    data
  })
}

//修改
export function editPrinter(data) {
  return http({
    url: '/api/printDrive/update',
    method: 'post',
    data
  })
}